import React, { useRef, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa6";


const References = () => {
  const [open, setOpen] = useState(true);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setOpen(!open);
  };
  return (
    <>
      <section className="py-8 px-4 lg:px-28">
        <div className="py-7 border-b border-gray-200 group">
          <div className="py-2 ">
            {/* Accordion Header */}
            <button
              className="w-full flex justify-between items-center text-left focus:outline-none"
              onClick={toggleAccordion}
            >
              <h2 className="my-5 text-2xl md:text-4xl font-light leading-[4.5rem]">
                Reference
              </h2>
              <div className="pr-5 mt-0.5 ml-2 text-gray-800 text-lg group-hover:text-gray-800">
                {open ? (
                  <div className="bg-red-500 rounded-full h-8 w-8 flex items-center justify-center">
                    <FaMinus className="text-white" />
                  </div>
                ) : (
                  <div className="bg-red-500 rounded-full h-8 w-8 flex items-center justify-center">
                    <FaPlus className="text-white" />
                  </div>
                )}
              </div>
            </button>

            {/* Accordion Content */}
            <div
              className={`transition-all duration-700 ease-in-out overflow-hidden`}
              style={{
                maxHeight: open
                  ? `${contentRef.current?.scrollHeight}px`
                  : "0px",
              }}
              ref={contentRef}
            >
              <div className="p-2">
                <ol className="mb-10 list-decimal list-outside px-6 space-y-4">
                  <li className="text-base text-gray-700">
                    Choudary P, et al. Diabetes Technol Ther 2024; 26 (Suppl.
                    3): S32-S37.
                  </li>
                  <li className="text-base text-gray-700">
                    Fusselman H, et al. FUSS2015D-P - The Extended Wear Infusion
                    Set - A Design for Plastic Waste Reduction. Virtual Diabetes
                    Technology Meeting. 2020.
                  </li>
                  <li className="text-base text-gray-700">
                    Collyns OJ, et al. Poster # 979 at the 80th International
                    Conference of the American Diabetes Association, June 2020,
                    Chicago/Virtual.
                  </li>
                  <li className="text-base text-gray-700">
                    Arrieta A, et al. Diabetes Obes Metab. 2022;24(7):1370-1379.
                  </li>
                  <li className="text-base text-gray-700">
                  Podatki družbe Medtronic: Anketa med uporabniki sistema MiniMed™ 780G, izvedena aprila in maja 2021 v Združenem kraljestvu, na Švedskem, v Italiji, na Nizozemskem in v Belgiji. 
                    <br /> Velikost vzorca = 789, 17 % uporabnikov je predhodno uporabljalo večkrat dnevne injekcije inzulina. 
                  </li>
                </ol>
                <p className="text-base text-gray-700">
                  * V primerjavi z večkrat dnevnimi injekcijami inzulina + intermitentnim kontinuiranim merjenjem glukoze
                  <br /> <br />
                  ** Več informacij najdete v uporabniškem priročniku, funkcija SmartGuard™. Potrebni so nekateri ukrepi uporabnika.
                  <br /> <br />
                  ^ Meritev glukoze v krvi (GK) je potrebna za vstop v funkcijo SmartGuard™. Če opozorila o glukozi in meritve neprekinjenega merjenja (CGM) niso skladne z vašimi simptomi, pred odločitvami o zdravljenju izmerite raven glukoze v krvi. Več informacij najdete v uporabniškem priročniku, funkcija SmartGuard™. Potrebni so nekateri ukrepi uporabnika.
                  <br /> <br />
                  ^^ Večkrat dnevno injiciranje (3-krat bolus in 1-krat bazalni inzulin na dan) zahteva 28 injiciranj na teden, v primerjavi z uporabo enega infuzijskega seta Medtronic Extended.
                  <br /> <br />
                  # Pričevanja uporabnikov so osebne izjave posameznikov v zvezi z zdravljenjem. Opis je pristen, značilen in dokumentiran. Vendar pa izkušnja posameznika ne predstavlja nikakršnega namiga, navodil, jamstva ali garancije glede morebitnih izkušenj drugih uporabnikov. Izkušnje drugih uporabnikov so lahko drugačne. Izkušnje uporabnikov se lahko razlikujejo in so specifične za posameznega uporabnika. 
                  <br /> <br />
                  ~ Več informacij najdete v uporabniškem priročniku Accu-Chek® Guide Link.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default References;
